import { Config } from '@/types/config';
import {
    FocusSummary, Team, UserWithEndAt
} from '@/types/interactionSummary';

export const mapFocusEventsByTeam = (data: FocusSummary[], teams: Team[], users: UserWithEndAt[], config: Config) => {
    const userIds: string[] = [...new Set(data.map((summary) => summary.userId.toString()))];
    const mappedEvents = [];
    for (const id of userIds) {
        const eventsByUser = data.filter((summary) => summary.userId === parseInt(id));
        const user = users.find((user) => user.id === parseInt(id));
        if (user) {
            const team = teams.find((team) => team.id === user.teamId);
            if (team) {
                const userMetrics = {
                    teamName: team.name,
                    userId: user.id,
                    userName: user.firstName + ' ' + user.lastName,
                    totalWorkEffortSecs: 0,
                    totalCount: 0,
                    totalIdleTimeSecs: 0,
                    workloadWorkEffortSecs: 0,
                    workloadCount: 0,
                    workloadIdleTimeSecs: 0,
                    otherWorkEffortSecs: 0,
                    otherCount: 0,
                    otherIdleTimeSecs: 0
                };
                for (const event of eventsByUser) {
                    const isProductive = checkIfWorkload(event.subDomain, config);
                    userMetrics.totalWorkEffortSecs += event.activeTimeSecs;
                    userMetrics.totalCount += event.countTotal;
                    userMetrics.totalIdleTimeSecs += event.idleTimeSecs;
                    if (isProductive) {
                        userMetrics.workloadWorkEffortSecs += event.activeTimeSecs;
                        userMetrics.workloadCount += event.countProductive;
                        userMetrics.workloadIdleTimeSecs += event.idleTimeSecs;
                    } else {
                        userMetrics.otherWorkEffortSecs += event.activeTimeSecs;
                        userMetrics.otherCount += (event.countTotal - event.countProductive);
                        userMetrics.otherIdleTimeSecs += event.idleTimeSecs;
                    }
                }
                mappedEvents.push(userMetrics);
            }
        }
    }
    return mappedEvents;
};
const checkIfWorkload = (domain: string, config: Config) => {
    return config.connectorData.chromeConnection.tracking.workloadURLs.some((workloadDomain) => {
        if (domain === workloadDomain.url) return true;
        return (
            workloadDomain.url.startsWith('*') &&
            domain.endsWith(workloadDomain.url.substring(1))
        );
    });
};

export const mapFocusEventsBySite = (data: FocusSummary[], config: Config, users: UserWithEndAt[]) => {
    const mappedEvents = [];
    const allDomains = [...new Set(data.map((summary) => summary.subDomain))];
    const domainEventMap: {[key: string]: FocusSummary[]}  = {};
    for (const domain of allDomains) {
        const relevantDataForDomain = data.filter((summary) => summary.subDomain === domain);
        domainEventMap[domain] = relevantDataForDomain;
    }
    for (const [ key, value ] of Object.entries(domainEventMap)) {
        for (const event of value) {
            const user = users.find((user) => user.id === event.userId);
            const isProductive = checkIfWorkload(event.subDomain, config);
            if (user) {
                const userMetrics = {
                    domain: key,
                    userName: user.firstName + ' ' + user.lastName,
                    workEffortSecs: event.activeTimeSecs,
                    count: event.countTotal,
                    idleTimeSecs: event.idleTimeSecs,
                    isProductive: isProductive ? 'Yes' : 'No'
                };
                mappedEvents.push(userMetrics);
            }
        }
    }
    return mappedEvents;
};
